<template >
  <div
    v-loading="loading"
    element-loading-text="正在加载中..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    style="height:100%;width:100%"
  >
    <div class="rc-title flex-between">
      <div>收款</div>
      <div class="back" @click="back('goHome')">X</div>
    </div>
    <div class="content">
      <div class="row tabs">
        <div
          @click="tabsClick(1)"
          :class="tabsIndex == 1?'tabsItem-checked':'tabsItem'"
          class="center row"
        >
          <img v-if="tabsIndex == 1" class="tabsIcon" src="../../assets/icon/smzf2.png" alt />
          <img v-else class="tabsIcon" src="../../assets/icon/smzf.png" alt />
          扫码支付
        </div>
        <div
          @click="tabsClick(2)"
          :class="tabsIndex == 2?'tabsItem-checked':'tabsItem'"
          class="center row"
        >
          <img v-if="tabsIndex == 2" class="tabsIcon" src="../../assets/icon/xjzf2.png" alt />
          <img v-else class="tabsIcon" src="../../assets/icon/xjzf.png" alt />
          现金支付
        </div>
        <div
          @click="tabsClick(3)"
          :class="tabsIndex == 3?'tabsItem-checked':'tabsItem'"
          class="center row"
        >
          <img v-if="tabsIndex == 3" class="tabsIcon" src="../../assets/icon/yesk2.png" alt />
          <img v-else class="tabsIcon" src="../../assets/icon/yesk.png" alt />
          余额收款
        </div>

        <div
          @click="tabsClick(4)"
          :class="tabsIndex == 4?'tabsItem-checked':'tabsItem'"
          class="center row"
        >
          <img v-if="tabsIndex == 4" class="tabsIcon" src="../../assets/icon/bjsk2.png" alt />
          <img v-else class="tabsIcon" src="../../assets/icon/bjsk.png" alt />
          标记收款
        </div>
      </div>
      <div v-if="tabsIndex==2" class="bjPay">
        <div class="bjPay-price center">应收金额：￥{{payList.payMoney}}</div>
        <div class="bjPay-price center" style="margin-top:0">找零：￥{{payList.giveChange}}</div>
        <div class="row">
          <el-input
            placeholder="实收金额"
            @input="inputWrite"
            type="number"
            v-model="payList.amountReceived"
          ></el-input>
        </div>
        <div class="center buttonGroup">
          <el-button type="primary" @click="writeRemark" plain>备注</el-button>
          <el-button type="primary" @click="back" plain>取消收款</el-button>
          <el-button type="primary" @click="cashPay">确认收款</el-button>
        </div>
      </div>
      <div v-if="tabsIndex==1" class="bjPay">
        <div class="bjPay-price center">应收金额：￥{{payList.payMoney}}</div>
        <div class="center codePay-img">
          <img src="../../assets/icon/smfk.png" alt />
        </div>
        <div class="bjPay-markedWords center">请使用扫码枪扫描付款码</div>
        <div class="row" style>
          <el-input placeholder="付款码" v-model="payList.barCode" ref="getFocus"></el-input>
          <!-- <div>找零:{{21312}}</div> -->
        </div>
        <div class="center buttonGroup">
          <el-button type="primary" @click="writeRemark" plain>备注</el-button>
          <el-button type="primary" @click="back" plain>取消收款</el-button>
          <el-button type="primary" :disabled="autoPay" @click="codePay">{{autoPay?'自动收款':'确认收款'}}</el-button>&nbsp;&nbsp;&nbsp; &nbsp;自动收款开关：
          <el-switch v-model="autoPay" @change="autoPayChange"></el-switch>
        </div>
      </div>
      <div v-if="tabsIndex==3" class="bjPay">
        <div class="bjPay-price center">应收金额：￥{{payList.payMoney}}</div>
        <!-- 请输入会员手机号获取余额信息 -->
        <div
          class="bjPay-markedWords center"
          v-if="$store.state.offers.type !== 4"
        ></div>
        <div class="bjPay-markedWords center" v-if="$store.state.offers.vipIfms.cardName && $store.state.offers.type !== 0 && $store.state.offers.type !== 1" style="font-size: 20px;padding-top: 20px;">
          {{$store.state.offers.vipIfms.cardName}} {{$store.state.offers.vipIfms.discount * 10}}折卡，余额
          <span
            style="color:#108EE9;font-weight:bold"
          >￥{{$store.state.offers.vipIfms.wallet.toFixed(2)}}</span>
        </div>
        <div class="bjPay-markedWords center" v-if="$store.state.offers.type == 1" style="font-size: 20px;padding-top: 20px;">会员：{{vipIfm.cardName}}</div>
        <div class="bjPay-markedWords center" v-if="$store.state.offers.type == 1" style="font-size: 20px;">
          优惠券满{{$store.state.offers.cashCoupon.minUsePrice}}元减{{$store.state.offers.cashCoupon.price}}元 , 余额
          <span
            style="color:#108EE9;font-weight:bold"
          >￥{{vipIfm.wallet.toFixed(2)}}</span>
        </div>
        <div class="row" style="margin-top:40px">
          <el-input
          v-if="memberPhone"
            placeholder="请输入会员手机号"
            v-model="payList.phoneNum"
            style="margin-right:10px"
          ></el-input>
          <el-button
            v-if="memberPhone"
            type="primary"
            @click="searchVip"
          >确定</el-button>
        </div>
        <div class="center buttonGroup">
          <el-button type="primary" @click="writeRemark" plain>备注</el-button>
          <el-button type="primary" @click="vipLogin" plain>更换会员</el-button>
          <el-button type="primary" @click="back" plain>取消收款</el-button>
          <el-button type="primary" @click="vipPay" :disabled="confirmDisabled">确认收款</el-button>
          <el-button
            v-if="$store.state.offers.type == 4"
            @click="jump('cashierOrderVip/vipRecharge',$store.state.offers.vipIfm.phoneNum)"
            type="primary"
          >会员充值</el-button>
        </div>
      </div>
      <div v-if="tabsIndex==4" class="bjPay">
        <div class="bjPay-price center">应收金额：￥{{payList.payMoney}}</div>
        <div class="bjPay-markedWords center">如你已使用以下方式向消费者收款，可以选择对应的标记收款</div>
        <div class="row center">
          <div
            @click="clickPayType(1)"
            :class="payTypeIndex == 1?'bjPay-payType2':'bjPay-payType'"
            class="row center"
          >
            <img
              class="typeIcon2"
              v-if="payTypeIndex == 1"
              src="../../assets/icon/topRight.png"
              alt
            />
            <img class="typeIcon" src="../../assets/icon/zypossk.png" alt />
            <div>
              <div>自有POS刷卡</div>
              <div class="text1">标记收款</div>
            </div>
          </div>
          <div
            @click="clickPayType(2)"
            :class="payTypeIndex == 2?'bjPay-payType2':'bjPay-payType'"
            class="row center"
          >
            <img
              class="typeIcon2"
              v-if="payTypeIndex == 2"
              src="../../assets/icon/topRight.png"
              alt
            />
            <img class="typeIcon" src="../../assets/icon/zywxzf.png" alt />
            <div>
              <div>自有微信支付</div>
              <div class="text1">标记收款</div>
            </div>
          </div>
          <div
            @click="clickPayType(3)"
            :class="payTypeIndex == 3?'bjPay-payType2':'bjPay-payType'"
            class="row center"
          >
            <img
              class="typeIcon2"
              v-if="payTypeIndex == 3"
              src="../../assets/icon/topRight.png"
              alt
            />
            <img class="typeIcon" src="../../assets/icon/zyzfb.png" alt />
            <div>
              <div>自有支付宝</div>
              <div class="text1">标记收款</div>
            </div>
          </div>
        </div>
        <div class="bjPay-markedWords center">标：标记收款禁用作记账，钱款不计入你的钱如潮店铺余额，你需要自行向消费者确认已经支付和收款到账。</div>
        <div class="center buttonGroup">
          <el-button type="primary" @click="writeRemark" plain>备注</el-button>
          <el-button type="primary" @click="back" plain>取消收款</el-button>
          <el-button type="primary" @click="writePay">确认收款</el-button>
        </div>
      </div>
    </div>

    <div class="orderMark">
      <div>备注:{{payList.orderMark}}</div>
    </div>
  </div>
</template>
<script>
import {
  preOrder,
  payByShopMemberCard,
  handleOrderForShopWorker,
  userPayScan,
  shopMemberList,
  Order_payResult
} from "../api";

export default {
  data() {
    return {
      loading: false, //扫码充值loading
      userList: "",
      shopInformation: "",
      tabsIndex: 1, //1 现金支付 2扫码支付 3 余额收款 4 标记收款
      payTypeIndex: 1, //1自有pos 2微信 3支付宝
      payList: {
        orderMark: "",
        payMoney: 0,
        giveChange: 0,
        amountReceived: 0,
        phoneNum: "",
        barCode: ""
      }, //支付所需字段
      orderArr: [], //生成的订单信息
      intervalNum: 0, //循环次数
      intervalStart: false, //开始循环
      vipIfm: [],
      codeMsg: "",
      autoPay: false, //自动收款开关
      payResult: { cartListTotalPrice: 0, cartListDiscounts: 0 },
      memberPhone: false,
      confirmDisabled: false,
      tradeNo: ""
    };
  },
  created() {
    console.log(localStorage.getItem("tabsIndex"), 'tabsIndex')
    if (localStorage.getItem("tabsIndex")) {
      this.tabsIndex = localStorage.getItem("tabsIndex")
    }
    this.autoPay = localStorage.getItem('autoPay') === "true" ? true : false
    if (this.$refs.getFocus) {
      this.$nextTick(() => {
        this.$refs.getFocus.focus()
      })
    }
    
    console.log(this.$store.state.offers, "111");
    let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.shopInformation = shopInformation;
    this.payList.payMoney = this.$store.state.cartListTotalPrice;
    // this.payList.payMoney = this.payList.payMoney.toFixed(2)
    this.payResult.cartListTotalPrice = this.$store.state.cartListTotalPrice;
    if (this.payResult.cartListTotalPrice) {
      console.log(this.payResult.cartListTotalPrice)
      // this.payResult.cartListTotalPrice = this.payResult.cartListTotalPrice.toFixed(2)
    }
    this.payResult.cartListDiscounts = this.$store.state.cartListDiscounts;
    this.vipIfm = this.$store.state.offers.vipIfm;
    console.log(this.vipIfm, 'this.vipIfm')
    console.log(this.$store.state.offers.vipIfms, 'vipIfms')
    console.log(this.$store.state.offers.type, '$store.state.offers.type')
    if (this.$store.state.offers.type == 0) {
      this.memberPhone = true
    }
    if (this.$store.state.offers.type == 2 || this.$store.state.offers.type == 3) {
      console.log(this.$store.state.offers.type, 'type')
      if (this.$store.state.offers.vipIfms.wallet) {
        this.$store.state.offers.vipIfms.wallet = this.$store.state.offers.vipIfms.wallet
      } else {
        this.memberPhone = true
      }
      if (this.$store.state.offers.vipIfms.wallet == 0) {
        this.memberPhone = false
      }
    }
    this.payList.amountReceived = this.$store.state.cartListTotalPrice;
    // this.payList.amountReceived = this.payList.amountReceived.toFixed(2)
    console.log(this.$store.state.offers.vipIfms.wallet, 'this.$store.state.offers.vipIfms.wallet', this.payList.payMoney, 'this.payList.payMoney')
    if (Number(this.$store.state.offers.vipIfms.wallet) < Number(this.payList.payMoney) && this.$store.state.offers.type == 4) {
      this.confirmDisabled = true
    } 
    if (Number(this.$store.state.offers.vipIfm.wallet) < Number(this.payList.payMoney) && this.$store.state.offers.type == 1) {
      this.confirmDisabled = true
    }
    console.log(this.tabsIndex, "this.tabsIndex")
    if (this.tabsIndex == 1) {
      this.onkeyDown();
    }
  },
  methods: {
    autoPayChange(e) {
      localStorage.setItem('autoPay', e)
    },
    // 更换会员
    vipLogin() {
      // this.$store.state.offers.vipIfm = []
      // if (this.$store.state.offers.type == 1) {
      //   this.$store.state.offers.type = 0
      //   this.$store.state.offers.cashCoupon = [];
      // } else if (this.$store.state.offers.type == 4) {
      //   this.$store.state.offers.type = 0
      // }
      this.memberPhone = true
      this.$store.commit("countTotalPrice");
      this.$store.commit("countCartListPrice");
      this.payList.phoneNum = "";
    },
    onkeyDown() {
      document.onkeydown = e => {
        if (e.key != "Enter") {
          if (e.key != "Backspace") {
            this.codeMsg += e.key;
          }
        } else {
          this.payList.barCode = this.codeMsg;
          this.codeMsg = "";
          if (this.autoPay && this.payList.barCode.length == 18) {
            this.loading = true
            this.userPayScan();
          } else {
            this.$message.error('请输入正确的付款码')
            this.loading = false
          }
        }
      };
    },   
    goResult() {
      console.log(this.orderArr.mallOrderId, "goRes");
      this.$router.push({
        path: "cashierOrderPay/result",
        query: {
          payResult: JSON.stringify(this.payResult),
          mallOrderId: this.orderArr.mallOrderId,
          tradeNo: this.tradeNo
        }
      });
      this.orderArr = [];
    },
    searchVip() {
      this.$store.state.status = 1
      if (/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.payList.phoneNum)) {
        this.loading = true
        this.shopMemberList(this.payList.phoneNum);
      } else {
        this.$message.error("请输入正确手机号");
      }
    },
    shopMemberList(phone11Num) {
      shopMemberList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        phone11Num: phone11Num
      })
        .then(res => {
          this.loading = false
          // console.log(res.data, "获取商品列表");
          if (res.code == 1) {
            this.$router.push({path:'cashierOrderVip/vipInformation',query:{phoneNum:this.payList.phoneNum}})
            this.$store.state.offers.vipIfm = res.data[0];
            this.vipIfm = res.data[0];
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else if (res.code == -1) {
            this.$message.error(this.payList.phoneNum + "还不是会员");
            this.$router.push({
              path: "cashierOrderVip/addVip",
              query: { phoneNum: this.payList.phoneNum }
            });
          }
        })
        .catch(function(error) {
          //   alert("商品接口网络错误，不能访问");
          //   console.log(error);
        });
    },
    jump(adress, query) {
      console.log(query, "qqq");
      this.$router.push({ path: adress, query: { phoneNum: query } });
    },
    writeRemark() {
      this.$prompt("请输入备注", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(({ value }) => {
          console.log(value.length, 123)
          this.$message({
            type: "success",
            message: "已备注: " + value
          });
          this.payList.orderMark = value;
        })
        .catch(() => {});
    },
    inputWrite(e) {
      this.payList.giveChange = (e - this.payList.payMoney).toFixed(2);
    },
    cashPay() {
      this.$confirm("请确认金额后，继续点确定", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
        // type: 'warning'
      })
        .then(() => {
          this.handleOrderForShopWorker();
          localStorage.removeItem('tabsIndex')
        })
        .catch(() => {});
    },
    clearAll() {
      this.payList = {
        orderMark: "",
        payMoney: 0,
        giveChange: 0,
        amountReceived: 0,
        phoneNum: "",
        barCode: ""
      };
      this.vipIfm = [];

      this.$store.commit("clearCartList");
      this.$store.commit("countTotalPrice");
      this.$store.commit("countCartListPrice");
      this.$store.state.saleUserId = ""
    },
    //轮询订单
    Order_payResult(mallOrderId, num) {
      Order_payResult({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        mallOrderId: mallOrderId
      }).then(res => {
        if (!num) {
          num = 0;
          num = num + 1;
        } else {
          num = num + 1;
        }
        console.log("轮询", num);
        if (num >= 10) {
          this.$message.error("支付失败");
          this.loading = false;
          return;
        }
        if (res.code == 1) {
          // this.orderList = res.data;
          // this.print();
          this.$message({
            type: "success",
            message: "支付成功"
          });
          this.loading = false;
          this.clearAll();
          this.goResult();
        } else {
          setTimeout(() => {
            this.Order_payResult(mallOrderId, num);
          }, 1000);
        }
      });
    },
    //余额收款
    vipPay() {
      this.$confirm("请确认收款金额后，继续点确定", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
        // type: 'warning'
      })
        .then(() => {
          this.payByShopMemberCard();
          localStorage.removeItem('tabsIndex')
        })
        .catch(() => {});
    },
    //标记买单
    writePay() {
      this.$confirm("请确认金额后，继续点确定", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
        // type: 'warning'
      })
        .then(() => {
          this.handleOrderForShopWorker2();
          localStorage.removeItem('tabsIndex')
        })
        .catch(() => {});
    },
    //扫码买单
    codePay() {
      if (this.payList.barCode.length == 18) {
        this.userPayScan();
        this.loading = true
        localStorage.removeItem('tabsIndex')
      } else {
        this.$message.error('请输入正确的付款码')
      }
      
      // this.$confirm("请确认收款金额后，继续点确定", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消"
      //   // type: 'warning'
      // })
      //   .then(() => {
      //     this.userPayScan();
      //   })
      //   .catch(() => {});
    },
    //扫码买单
    userPayScan() {
      if (this.payList.payMoney <= 0) {
        this.$message.error("商品不得为空");
        return;
      }

      if (this.intervalStart) {
        //判断是否已开始循环
        this.$message.error("十秒内只能支付一次");
        return;
      }
      this.preOrder();
      this.intervalStart = true;
      //循环为解决创建订单异步问题，防止拿不到订单号
      var interval = setInterval(res => {
        // console.log(this.intervalNum, "fail");
        this.intervalNum++;
        if (this.intervalNum > 10) {
          clearInterval(interval);
          this.intervalStart = false;
          this.intervalNum = 0;
        }
        if (this.orderArr && this.orderArr.length != 0) {
          console.log("success");
          clearInterval(interval);
          userPayScan({
            sessionId: this.userList.sessionId,
            userId: this.userList.id,
            auth_code: this.payList.barCode,
            mallOrderId: this.orderArr.mallOrderId,
            orderMark: this.payList.orderMark
          })
            .then(res => {
              if (res.code == 1) {
                // this.loading = true;
                this.Order_payResult(this.orderArr.mallOrderId);
                this.intervalStart = false;
              } else if (res.code == 2) {
                this.$message.error(res.msg);
                this.$router.push("/");
              } else {
              }
            })
            .catch(function(error) {});
        }
      }, 1000);
    },
    //使用会员卡买单
    payByShopMemberCard() {
      if (this.vipIfm.length <= 0) {
        this.$message.error("请先登录会员");
        return;
      }
      if (this.payList.payMoney <= 0) {
        this.$message.error("商品不得为空");
        return;
      }
      this.preOrder();
      if (this.intervalStart) {
        //判断是否已开始循环
        this.$message.error("十秒内只能支付一次");
        return;
      }
      this.intervalStart = true;
      //循环为解决创建订单异步问题，防止拿不到订单号
      var interval = setInterval(res => {
        // console.log(this.intervalNum, "fail");
        this.intervalNum++;
        if (this.intervalNum > 10) {
          clearInterval(interval);
          this.intervalStart = false;
          this.intervalNum = 0;
        }
        if (this.orderArr && this.orderArr.length != 0) {
          console.log("success");
          clearInterval(interval);
          this.intervalStart = false;
          payByShopMemberCard({
            sessionId: this.userList.sessionId,
            userId: this.userList.id,
            payMoney: this.payList.payMoney,
            mallOrderId: this.orderArr.mallOrderId,
            orderMark: this.payList.orderMark,
            shopMemberId: this.vipIfm.shopMemberId
          })
            .then(res => {
              if (res.code == 1) {
                this.loading = true;
                this.Order_payResult(this.orderArr.mallOrderId);
              } else if (res.code == 2) {
                this.$message.error(res.msg);
                this.$router.push("/");
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch(function(error) {});
        }
      }, 1000);
    },
    //标记收款
    handleOrderForShopWorker2() {
      if (this.payList.payMoney <= 0) {
        this.$message.error("商品不得为空");
        return;
      }
      this.preOrder();
      if (this.intervalStart) {
        //判断是否已开始循环
        this.$message.error("十秒内只能支付一次");
        return;
      }
      this.intervalStart = true;
      //循环为解决创建订单异步问题，防止拿不到订单号
      var interval = setInterval(res => {
        // console.log(this.intervalNum, "fail");
        this.intervalNum++;
        if (this.intervalNum > 10) {
          clearInterval(interval);
          this.intervalStart = false;
          this.intervalNum = 0;
        }
        if (this.orderArr && this.orderArr.length != 0) {
          console.log("success");
          clearInterval(interval);
          this.intervalStart = false;
          var payInterfacePartyType;
          if (this.payTypeIndex == 1) {
            payInterfacePartyType = 8;
          } else if (this.payTypeIndex == 2) {
            payInterfacePartyType = 13;
          } else if (this.payTypeIndex == 3) {
            payInterfacePartyType = 12;
          }
          handleOrderForShopWorker({
            sessionId: this.userList.sessionId,
            userId: this.userList.id,
            payMoney: this.payList.payMoney,
            mallOrderId: this.orderArr.mallOrderId,
            orderMark: this.payList.orderMark,
            payInterfacePartyType: payInterfacePartyType
          })
            .then(res => {
              if (res.code == 1) {
                this.loading = true;
                this.Order_payResult(this.orderArr.mallOrderId);
              } else if (res.code == 2) {
                this.$message.error(res.msg);
                this.$router.push("/");
              } else {
              }
            })
            .catch(function(error) {});
        }
      }, 1000);
    },
    //现金收款
    handleOrderForShopWorker() {
      if (
        Number(this.payList.amountReceived) <= 0 ||
        Number(this.payList.amountReceived) < Number(this.payList.payMoney)
      ) {
        this.$message.error("实收金额要大于应收金额");
        return;
      }
      if (this.payList.payMoney <= 0) {
        this.$message.error("商品不得为空");
        return;
      }
      this.preOrder();

      if (this.intervalStart) {
        //判断是否已开始循环
        this.$message.error("十秒内只能支付一次");
        return;
      }
      this.intervalStart = true;
      //循环为解决创建订单异步问题，防止拿不到订单号
      var interval = setInterval(res => {
        // console.log(this.intervalNum, "fail");
        this.intervalNum++;
        if (this.intervalNum > 10) {
          clearInterval(interval);
          this.intervalStart = false;
          this.intervalNum = 0;
        }
        if (this.orderArr && this.orderArr.length != 0) {
          console.log("success");
          clearInterval(interval);
          this.intervalStart = false;
          handleOrderForShopWorker({
            sessionId: this.userList.sessionId,
            userId: this.userList.id,
            payMoney: this.payList.payMoney,
            mallOrderId: this.orderArr.mallOrderId,
            orderMark: this.payList.orderMark,
            amountReceived: Number(this.payList.amountReceived),
            giveChange: Number(this.payList.giveChange)
          })
            .then(res => {
              if (res.code == 1) {
                this.loading = true;
                this.Order_payResult(this.orderArr.mallOrderId);
              } else if (res.code == 2) {
                this.$message.error(res.msg);
                this.$router.push("/");
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch(function(error) {});
        }
      }, 1000);
    },
    //生成订单
    preOrder() {
      var state = this.$store.state;
      var customPrice, cashCouponId, shopMemberId, customDiscount;
      var productData = [];
      console.log(state, state.cartList);
      for (var i of state.cartList) {
        console.log(i, "i");
        if (i.goodsName == "无码商品") {
          productData.push({
            goodsId: 0,
            productId: 0,
            qrcBuyCount: i.goodsNum,
            discountPrice: i.retailPrice
          });
        } else {
		  var item = {
			goodsId: i.goodsId,
			productId: i.productId,
			qrcBuyCount: i.goodsNum
		  }
		  if(i.discountPrice){
			  item.discountPrice = i.discountPrice
		  }
          productData.push(item);
        }
      }
      //1:优惠券 2:整单改价金额 3：整单折扣 4：会员卡
      if (state.offers.type == 1) {
        cashCouponId = state.offers.cashCoupon.cashCouponId;
      } else if (state.offers.type == 2) {
        customPrice = state.offers.reducePrice;
      } else if (state.offers.type == 3) {
        customDiscount = (state.offers.discountNumber / 10).toFixed(2);
      } else if (state.offers.type == 4) {
        shopMemberId = state.offers.vipIfm.shopMemberId;
      }
      preOrder({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        payMoney: Number(this.payList.payMoney),
        cashCouponId: cashCouponId,
        shopMemberId: shopMemberId,
        customDiscount: customDiscount,
        customPrice: customPrice,
        productData: JSON.stringify(productData),
        saleUserId: this.$store.state.saleUserId
      })
        .then(res => {
          if (res.code == 1) {
            console.log(res.data, "111");
            this.orderArr = res.data;
            this.tradeNo = res.data.tradeNo
            console.log(this.tradeNo, "订单号")
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(function(error) {});
    },
    clickPayType(index) {
      this.payTypeIndex = index;
    },
    tabsClick(index) {
      this.tabsIndex = index;
      localStorage.setItem("tabsIndex", this.tabsIndex)
      if (this.tabsIndex == 1) {
        this.onkeyDown();
        this.$nextTick(() => {
          this.$refs.getFocus.focus()
        })
      } else {
        document.onkeydown = "";
      }
    },
    back(a) {
      document.onkeydown = "";
      this.$emit("back")
      if (a) {
        this.$router.push("/cashierOrder/cashierOrderHome");
        // this.$router.push({path: '/cashierOrder/cashierOrderHome', query: { params: 1}})
        return;
      }
      this.$router.go(-1);
    }
  },
  watch: {
    codeMsg: function(oldValue, newValue) {
      console.log(this.codeMsg, "code改变");
      if (this.codeMsg.length == 18) {
        // document.onkeydown = "";
        if (this.autoPay) {
          this.userPayScan();
        }
      }
    }
  }
};
</script>
<style  scoped>
.buttonGroup {
  margin-top: 40px;
}
.text1 {
  font-size: 14px;
  font-family: PingFang;
  font-weight: 500;
  color: rgba(153, 153, 153, 1);
  margin-top: 10px;
  cursor: pointer;
}

.typeIcon2 {
  height: 25px;
  width: 25px;
  position: absolute;
  top: 0;
  right: 0;
}
.typeIcon {
  height: 40px;
  width: 40px;
  margin-right: 28px;
}
.bjPay-payType2 {
  height: 110px;
  width: 240px;
  border-radius: 3px;
  border: 1px solid rgba(51, 132, 249, 1);
  box-shadow: 0px 0px 16px 0px rgba(208, 208, 208, 0.4);
  position: relative;
  margin-top: 50px;
  margin-right: 26px;
  box-sizing: border-box;
  cursor: pointer;
}
.bjPay-payType {
  margin-top: 50px;
  height: 110px;
  width: 240px;
  margin-right: 26px;
  cursor: pointer;
}
.bjPay-markedWords {
  margin-top: 20px;
  margin-bottom: 40px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(90, 93, 90, 1);
}
.bjPay {
  position: absolute;
  top: 110px;
  /* width: 100%; */
}
.bjPay-price {
  margin-top: 40px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(0, 51, 51, 1);
  line-height: 48px;
}
.tabs {
  position: absolute;
  top: 40px;
  width: 50%;
  height: 60px;
}
.tabsItem-checked {
  /* padding: 20px 37px; */
  background: #108ee9;
  color: #fff;
  margin-right: 10px;
  display: flex;
  flex-grow: 1;
  height: 100%;
}
.tabsItem {
  cursor: pointer;
  /* padding: 20px 37px; */
  background: #f8f8f9;
  margin-right: 10px;
  display: flex;
  flex-grow: 1;
  height: 100%;
}
.tabsIcon {
  height: 23px;
  width: 23px;
  margin-right: 5px;
}
.codePay-img img {
  max-width: 210px;
  height: auto;
}
.content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  left: 0;
  right: 0;
  top: 60px;
  bottom: 60px;
}
.back {
  color: gray;
  font-size: 20px;
  cursor: pointer;
}
.orderMark {
  /* background: #eeeeee; */
  border-top: 1px solid #eee;
  box-sizing: border-box;
  padding: 18px;
  height: 60px;
  font-size: 16px;
  position: absolute;
  bottom: 0;
  width: 100%;
}
.rc-title {
  /* background: #eeeeee; */
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
  padding: 18px;
  height: 60px;
  font-size: 16px;
}
@media screen and (min-width: 1650px) {
}
@media screen and (max-width: 1280px) {
  .tabs {
    width: 90%;
    font-size: 10px;
  }
  .tabsIcon {
    height: 11px;
    width: 11px;
    margin-right: 2px;
  }
}
@media screen and (max-height: 840px) {
  .bjPay-price {
    margin-top: 0px;
  }
  .codePay-img img {
    max-width: 100px;
  }
  .bjPay-markedWords {
    margin-bottom: 10px;
    margin-top: 0;
    font-size: 12px;
  }
  .buttonGroup {
    margin-top: 10px;
  }
  .orderMark {
    padding: 10px;
    height: 30px;
    font-size: 12px;
  }
  .bjPay-payType2 {
    height: 55px;
    width: 120px;
    font-size: 12px;
    margin-top: 25px;
    margin-right: 13px;
    margin-bottom: 10px;
  }
  .bjPay-payType {
    height: 55px;
    width: 120px;
    font-size: 12px;
    margin-top: 25px;
    margin-right: 13px;
    margin-bottom: 10px;
  }
  .typeIcon {
    height: 20px;
    width: 20px;
    margin-right: 10px;
  }
  .typeIcon2 {
    height: 12px;
    width: 12px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/page/cashierOrderPay.vue